import { ROLE_ADMIN, ROLE_TEACHER } from "app/config/roles";
import {
  Dashboard,
  School,
  Business,
  Groups,
  ContactMail,
  InventoryOutlined,
  ManageAccounts,
  OndemandVideo,
  VideoSettings,
  CurrencyRupee,
  Receipt,
  People,
  Badge,
  Settings,
  Class,
  Apartment,
  Message,
  WhatsApp,
  Sms,
  Security,
  AdminPanelSettings,
  AccountTree,
  Payment,
  AccessTime,
} from "@mui/icons-material";
import appRoutes from "./routes";

export const sidebarItems = [
  // Dashboard
  {
    key: "dashboard",
    name: "Dashboard",
    icon: <Dashboard size={15} />,
    link: `/dashboard`,
    roles: [ROLE_ADMIN, ROLE_TEACHER],
    module: "DASHBOARD",
    screenName: "DASHBOARD",
  },

  // Institute
  {
    key: "institute",
    name: "Institute",
    icon: <School size={15} />,
    roles: [ROLE_ADMIN, ROLE_TEACHER],
    module: "INSTITUTE",
    screenName: "INSTITUTE",
    subMenu: [
      {
        key: "instituteGroup",
        name: "Institute Group",
        icon: <Groups size={15} />,
        link: appRoutes.instituteGroup,
        roles: [ROLE_ADMIN, ROLE_TEACHER],
        module: "INSTITUTE",
        screenName: "INSTITUTE_GROUP",
      },

      // Institute List
      {
        key: "instituteList",
        name: "Institute List",
        icon: <Business size={15} />,
        link: appRoutes.instituteList,
        roles: [ROLE_ADMIN, ROLE_TEACHER],
        module: "INSTITUTE",
        screenName: "INSTITUTE_LIST",
      },

      // Institute List
      {
        key: "sessionWiseInstituteList",
        name: "Session Wise Institute List",
        icon: <Business size={15} />,
        link: appRoutes.sessionWiseInstituteList,
        roles: [ROLE_ADMIN, ROLE_TEACHER],
        module: "INSTITUTE",
        screenName: "INSTITUTE_LIST",
      },

      // Institute Enquiry
      {
        key: "enquiry",
        name: "Institute Enquiry",
        icon: <ContactMail size={15} />,
        link: appRoutes.instituteEnquiry,
        roles: [ROLE_ADMIN, ROLE_TEACHER],
        module: "INSTITUTE",
        screenName: "INSTITUTE_ENQUIRY",
      },
      {
        key: "userProfile",
        name: "User Profile",
        icon: <ManageAccounts size={15} />,
        link: appRoutes.schoolUserProfile,
        roles: [ROLE_ADMIN, ROLE_TEACHER],
        module: "USER_PROFILE",
        screenName: "USER_PROFILE",
      },
    ],
  },

  // PRODUCT
  {
    key: "product",
    name: "Product",
    icon: <InventoryOutlined size={15} />,
    link: appRoutes.product,
    roles: [ROLE_ADMIN, ROLE_TEACHER],
    module: "PRODUCT",
    screenName: "PRODUCT",
  },

  // Subscriptions
  {
    key: "subscriptions",
    name: "Subscriptions",
    icon: <CurrencyRupee size={15} />,
    roles: [ROLE_ADMIN, ROLE_TEACHER],
    module: "SUBSCRIPTIONS",
    screenName: "SUBSCRIPTIONS",
    subMenu: [
      {
        key: "subscriptions",
        name: "Subscriptions",
        icon: <CurrencyRupee size={15} />,
        link: appRoutes.subscriptions,
        roles: [ROLE_ADMIN, ROLE_TEACHER],
        module: "SUBSCRIPTIONS",
        screenName: "SUBSCRIPTIONS",
      },
      {
        key: "plans",
        name: "Plans",
        icon: <Receipt size={15} />,
        link: appRoutes.plans,
        roles: [ROLE_ADMIN, ROLE_TEACHER],
        module: "SUBSCRIPTIONS",
        screenName: "PLANS",
      },
      {
        key: "customerSubscriptions",
        name: "Customer Subscriptions",
        icon: <AccessTime size={15} />,
        link: appRoutes.customerSubscriptions,
        roles: [ROLE_ADMIN, ROLE_TEACHER],
        module: "SUBSCRIPTIONS",
        screenName: "CUSTOMER_SUBSCRIPTIONS",
      },
    ],
  },

  // Collection
  {
    key: "collection",
    name: "Collection",
    icon: <CurrencyRupee size={15} />,
    roles: [ROLE_ADMIN, ROLE_TEACHER],
    module: "COLLECTION",
    screenName: "COLLECTION",
    subMenu: [
      {
        key: "erpCollection",
        name: "ERP Collection",
        icon: <Receipt size={15} />,
        link: appRoutes.erpCollection,
        roles: [ROLE_ADMIN, ROLE_TEACHER],
        module: "COLLECTION",
        screenName: "ERP_COLLECTION",
      },
      {
        key: "taxInvoice",
        name: "Tax Invoice",
        icon: <Receipt size={15} />,
        link: appRoutes.taxInvoice,
        roles: [ROLE_ADMIN, ROLE_TEACHER],
        module: "COLLECTION",
        screenName: "TAX_INVOICE",
      },
      {
        key: "dueFollowUp",
        name: "Due Follow Up",
        icon: <AccessTime size={15} />,
        link: appRoutes.dueFollowUp,
        roles: [ROLE_ADMIN, ROLE_TEACHER],
        module: "COLLECTION",
        screenName: "DUE_FOLLOW_UP",
      },
    ],
  },
  // Courses
  {
    key: "courses",
    name: "Courses",
    icon: <OndemandVideo size={15} />,
    roles: [ROLE_ADMIN, ROLE_TEACHER],
    module: "COLLECTION",
    screenName: "COLLECTION",
    subMenu: [
      {
        key: "courseManagement",
        name: "Course Management",
        icon: <VideoSettings size={15} />,
        link: appRoutes.courseManagement,
        roles: [ROLE_ADMIN, ROLE_TEACHER],
        module: "COLLECTION",
        screenName: "ERP_COLLECTION",
      },
    ],
  },

  // Staff ID Card
  // {
  //   key: "staffIdCard",
  //   name: "Staff ID Card",
  //   icon: <InventoryOutlined size={15} />,
  //   link: appRoutes.staffIdCard,
  //   roles: [ROLE_ADMIN, ROLE_TEACHER],
  //   module: "STAFF_ID_CARD",
  //   screenName: "STAFF_ID_CARD",
  // },

  //Ekalsutra Staff
  {
    key: "ekalsutraStaff",
    name: "ES Staff",
    icon: <InventoryOutlined size={15} />,
    link: appRoutes.ekalsutraStaff,
    roles: [ROLE_ADMIN, ROLE_TEACHER],
    module: "EKALSUTRA_STAFF",
    screenName: "EKALSUTRA_STAFF",
  },
  // Student Management
  {
    key: "student-management",
    name: "Student Management",
    icon: <People size={15} />,
    roles: [ROLE_ADMIN, ROLE_TEACHER],
    module: "STUDENT_MANAGEMENT",
    screenName: "STUDENT_MANAGEMENT",
    subMenu: [
      {
        key: "students",
        name: "Students",
        icon: <People size={15} />,
        link: `${appRoutes.students}`,
        roles: [ROLE_ADMIN, ROLE_TEACHER],
        module: "STUDENT_MANAGEMENT",
        screenName: "STUDENT",
      },
      {
        key: "id-card",
        name: "ID Card",
        icon: <Badge size={15} />,
        link: appRoutes.idCard,
        roles: [ROLE_ADMIN, ROLE_TEACHER],
        module: "STUDENT_MANAGEMENT",
        screenName: "IDCARD",
      },
    ],
  },

  // Institute Management
  {
    key: "instituteManagement",
    name: "Institute Management",
    icon: <Settings size={15} />,
    roles: [ROLE_ADMIN, ROLE_TEACHER],
    module: "INSTITUTE_MANAGEMENT",
    screenName: "INSTITUTE_MANAGEMENT",
    subMenu: [
      {
        key: "sessionSetting",
        name: "Session Setting",
        icon: <Settings size={15} />,
        link: appRoutes.sessionSetting,
        roles: [ROLE_ADMIN, ROLE_TEACHER],
        module: "INSTITUTE_MANAGEMENT",
        screenName: "SESSION_SETTING",
      },
      {
        key: "class",
        name: "Class",
        icon: <Class size={15} />,
        link: appRoutes.class,
        roles: [ROLE_ADMIN, ROLE_TEACHER],
        module: "INSTITUTE_MANAGEMENT",
        screenName: "CLASS",
      },
      {
        key: "department",
        name: "Department",
        icon: <Apartment size={15} />,
        link: appRoutes.department,
        roles: [ROLE_ADMIN, ROLE_TEACHER],
        module: "INSTITUTE_MANAGEMENT",
        screenName: "DEPARTMENT",
      },
    ],
  },

  // Communication
  {
    key: "communication",
    name: "Communication",
    icon: <Message size={15} />,
    roles: [ROLE_ADMIN, ROLE_TEACHER],
    module: "COMMUNICATION",
    screenName: "COMMUNICATION",
    subMenu: [
      {
        key: "whatsAppTemplate",
        name: "Whats-App Templates",
        icon: <WhatsApp size={15} />,
        link: appRoutes.whatsAppTemplate,
        roles: [ROLE_ADMIN, ROLE_TEACHER],
        module: "COMMUNICATION",
        screenName: "WHATS_APP_TEMPLATE",
      },
      {
        key: "text",
        name: "Text Sms",
        icon: <Sms size={15} />,
        link: appRoutes.textSms,
        roles: [ROLE_ADMIN, ROLE_TEACHER],
        module: "COMMUNICATION",
        screenName: "TEXT_SMS",
      },
    ],
  },

  // Access Control
  {
    key: "access-control",
    name: "Access Control",
    icon: <Security size={15} />,
    roles: [ROLE_ADMIN, ROLE_TEACHER],
    module: "ACCESS_CONTROL",
    screenName: "ACCESS_CONTROL",
    subMenu: [
      {
        key: "schoolErp",
        name: "School ERP",
        icon: <AdminPanelSettings size={15} />,
        link: appRoutes.schoolErp,
        roles: [ROLE_ADMIN, ROLE_TEACHER],
        module: "ACCESS_CONTROL",
        screenName: "SCHOOL_ERP",
      },
      {
        key: "orgErp",
        name: "Org ERP",
        icon: <AdminPanelSettings size={15} />,
        link: appRoutes.orgErp,
        roles: [ROLE_ADMIN, ROLE_TEACHER],
        module: "ACCESS_CONTROL",
        screenName: "ORG_ERP",
      },
    ],
  },

  // Tenant Management
  {
    key: "tenant-management",
    name: "Tenant Management",
    icon: <AccountTree size={15} />,
    roles: [ROLE_ADMIN, ROLE_TEACHER],
    module: "TENANT_MANAGEMENT",
    screenName: "TENANT_MANAGEMENT",
    subMenu: [
      {
        key: "tenantList",
        name: "Tenant List",
        icon: <ManageAccounts size={15} />,
        link: appRoutes.tenantList,
        roles: [ROLE_ADMIN, ROLE_TEACHER],
        module: "TENANT_MANAGEMENT",
        screenName: "TENANT_LIST",
      },
    ],
  },

  //Razorpay
  {
    key: "paymet-gateway",
    name: "Payment Gateway",
    icon: <Payment size={15} />,
    link: appRoutes.paymentGateway,
    roles: [ROLE_ADMIN, ROLE_TEACHER],
    module: "PAYMENT_GATEWAY",
    screenName: "PAYMENT_GATEWAY",
  },
];
